<template>
  <div class="bg-main registrateProgress">
    <div class="listTitle"></div>
    <card-wrap title="我的报名进展" class="cardWraps">
      <div>
        <van-steps direction="vertical" :active="activeIndex" :active-color="'rgb(5,108,223)'"
          :inactive-color="'rgb(5,108,223)'">
          <van-step v-for="(item, index) in activities" :key="index">
            <div class="titleContent">
              <h3>{{ item.content }}</h3>
              <button v-if="dataForm.approvalStatus < 4 && index == 3" @click.stop.prevent="revise"
                class="revise">修改</button>
            </div>
            <div class="descContent">
              <p>{{ item.desc }}</p>
              <span>{{ item.timeplate }}</span>
            </div>
          </van-step>
        </van-steps>
      </div>
      <!-- <div class="jd">
        <p>最终录取结果</p>
        <span>在“个人中心”中可查看审核状态审核工作将在5个工作日内完成，请关注通知</span>
      </div> -->
    </card-wrap>
    <card-wrap title="我的报名意向" class="cardWraps">
      <van-cell title="报读专业" :value="dataForm.specialtyName" />
      <van-cell title="报读教学中心" :value="`${dataForm.branchName},${dataForm.schoolName}`" />
    </card-wrap>
    <card-wrap title="我的报名信息" class="cardWraps">
      <van-cell title="报读人" :value="dataForm.name" />
      <van-cell title="手机号" :value="dataForm.mobilePhoneNum" />
      <van-cell title="证件类型" :value="dataForm.identityTypeName" />
      <van-cell title="证件号" :value="dataForm.identityNum" />
      <van-cell title="邮箱" :value="dataForm.email" />
      <van-cell title="报名时间" :value="dataForm.createTime" />
    </card-wrap>
    <card-wrap title="基础信息" class="cardWraps">
      <van-cell title="性别" :value="['男', '女'][dataForm.gender - 0]" />
      <van-cell title="出生日期" :value="dataForm.birthDate" />
      <van-cell title="民族" :value="dataForm.nationName" />
      <van-cell title="政治面貌" :value="dataForm.politicalStatusName" />
      <van-cell title="通信地址" :value="fieldValue" />
      <van-cell title="详细地址" :value="dataForm.communicationDetailedAddress" />
    </card-wrap>
    <card-wrap title="证件信息" class="cardWraps">
      <van-cell title="个人证件照" value="查看" @click="goPersonalPhoto" />
      <van-cell title="身份证正反面" value="查看" @click="goFrontBackIdCard" />
    </card-wrap>
    <card-wrap title="工作学历经历">
      <van-cell title="前置学历" :value="dataForm.oldDegreeLevelName" />
      <van-cell title="毕业院校" :value="dataForm.oldGraduated" />
      <van-cell title="前置学历证明" value="查看" @click="goPreposeDiploma" />
      <van-cell title="工作证明" value="查看" @click="goWorkCertificate" />
    </card-wrap>
  </div>
</template>

<script>
import { getStudentInfo, queryRegistrationProgress } from '@/api/login'
import cardWrap from "@/pages/Home/component/cardWrap.vue";
import { admindivisionFirstList, admindivisionNextList, getBranchListBySpecialtyId, getDeclareCentersBySchoolId } from '@/api/home' // 省份及下级
import { getFileUrl } from "@/api/common/index"// 上传

export default {
  name: "",
  data() {
    return {
      activeIndex: 4,
      activities: [],
      dataForm: {},
      fieldValue: ''
    }
  },
  components: { cardWrap },
  created() {
    this.getStudentInfoFn()
  },
  watch: {
    $route(val) {
      if (val.path == '/registrateProgress') {
        this.getStudentInfoFn()
      }
    }
  },
  methods: {
    getStudentInfoFn() {
      getStudentInfo().then(res => {
        if (res) {
          this.showDataFn(res)
          this.dataForm = res
          this.queryRegistrationProgressFn()
        }
      })
    },

    queryRegistrationProgressFn() {
      queryRegistrationProgress({ studentId: this.dataForm.studentId }).then(res => {

        this.watchjz(res)
      })
    },

    // 数据回显
    async showDataFn(data) {

      // 照片
      getFileUrl({ objectKey: data.photo }).then(datas => {
        data.photoShow = datas
      })

      // 省市区
      admindivisionFirstList().then(res => {
        data.communicationProvince && this.provinceCityAreaShow(data, res)
      })
    },
    // 省市区回显
    async provinceCityAreaShow(data, provinceList) {
      // 省市区
      const communicationProvinceItem = provinceList.filter(item => item.areaCode == data.communicationProvince)
      this.fieldValue = communicationProvinceItem[0].areaName
      // 市
      communicationProvinceItem[0].children = await admindivisionNextList(communicationProvinceItem[0].areaCode)// 市列表
      const CityItem = communicationProvinceItem[0].children.filter(item => item.areaCode == data.communicationPrefecturalCity)
      this.fieldValue = this.fieldValue + '/' + CityItem[0].areaName
      // 区域
      CityItem[0].children = await admindivisionNextList(CityItem[0].areaCode) // 区
      const areaItem = CityItem[0].children.filter(item => item.areaCode == data.communicationGroundArea)
      this.fieldValue = this.fieldValue + '/' + areaItem[0].areaName
      // 街道
      if (data.communicationStreet) {
        areaItem[0].children = await admindivisionNextList(areaItem[0].areaCode) // 区
        const streetItem = areaItem[0].children.filter(item => item.areaCode == data.communicationStreet)
        this.fieldValue = this.fieldValue + '/' + streetItem[0].areaName
      }
    },
    // 报名进展
    watchjz(data) {
      // 0保存 1提交 2 待初审 3 初审不通过 
      // 如果状态小于4 则都可以修改

      if (this.dataForm.approvalStatus < 4) {// 都可以修改
        this.activities = [
          { content: '最终录取结果', desc: '在“个人中心”中可查看审核状态审核工作将在5个工作日内完成，请关注通知' },
          { content: '报名资格初审', desc: '审核工作将在5个工作日内完成，请关注通知' },
          { content: '缴纳学费', desc: '请联系报名教学中心老师缴纳学费' },
          { content: '信息确认', desc: '可进行信息修改和采集照片' },
          { content: '报读意向', desc: '已经完成', timeplate: data.filter(item => item.status == 0)[0].createTime }
        ]
      } else {
        this.activities = [
          { content: '最终录取结果', desc: '在“个人中心”中可查看审核状态审核工作将在5个工作日内完成，请关注通知' },
          { content: '报名资格审批', desc: '已完成', timeplate: data.filter(item => item.status == 3)[0].createTime },
          { content: '缴纳学费', desc: '已完成', timeplate: data.filter(item => item.status == 2)[0].createTime },
          { content: '报读意向', desc: '已完成', timeplate: data.filter(item => item.status == 0)[0].createTime }
        ]
        this.activeIndex = 1
        if (this.dataForm.approvalStatus == 10) {// 总部审核通过
          this.activities[0] = { content: '最终录取结果', desc: '恭喜您已被成功录取', timeplate: data.filter(item => item.status == 4)[0].createTime }
          this.activeIndex = 0
        }
      }
    },
    // 修改
    revise() {
      this.$router.push({ name: 'home', params: { type: 'edit' } })
    },
    // 证件照
    goPersonalPhoto() {
      this.$store.commit('setPhoto', this.dataForm.photo);
      this.$router.push({ name: 'uploadTemp', query: { identityNum: this.dataForm.identityNum, disabled: true } })
    },
    // 身份证正反面
    goFrontBackIdCard() {
      this.$store.commit('setIdCard', { identityCardFront: this.dataForm.identityCardFront, identityCardBack: this.dataForm.identityCardBack });
      this.$router.push({ name: 'idCard', query: { disabled: true } })
    },
    // 前置学历证书电子版
    goPreposeDiploma() {
      this.$store.commit('setPreposeDiploma', this.dataForm.preposeDiploma)
      this.$router.push({ name: 'diploma', query: { disabled: true } })
    },
    //工作证明
    goWorkCertificate() {
      this.$store.commit('setWorkCertificate', this.dataForm.workCertificate)
      this.$router.push({ name: 'work', query: { isRequireWorkCertificate: this.isRequireWorkCertificate, disabled: true } })
    }

  },
};
</script>
<style scoped>
.registrateProgress {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  min-height: 100vh;
}

.jd {
  margin-top: 20px;
  display: flex;
}

.jd p {
  width: 190px;
}

.jd span {
  color: #666;
  font-size: 13px;
}

.cardWraps {
  margin-bottom: 10px;
}

.revise {
  height: 30px !important;
}

.titleContent {
  display: flex;
  align-items: center;
}

.titleContent h3 {
  margin-right: 20px;
}

.descContent {
  display: flex;
}

.descContent p {
  margin-right: 20px;
}
</style>
